import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #d6d6d6;
  height: 80vh;

  @media (max-width: 900px) {
  }
`;

export const Text = styled.div`
  font-size: 24px;
  color: #d6d6d6;
  text-align: center;
`;

export const ButtonContainer = styled.a`
  text-decoration: none;
  color: inherit;

  &:hover,
  &:focus,
  &:active {
    text-decoration: none;
    color: inherit;
  }
`;

export const HiButton = styled.div`
  color: white;
  background: none;
  border-radius: 0;
  text-transform: uppercase;
  padding: 1em 1.3em;
  letter-spacing: 0.35em;
  font-size: 1em;
  transition: background-color 0.3s, box-shadow 0.3s, color 0.3s;
  margin: 1em;
  cursor: pointer;

  &.white {
    box-shadow: inset 0 0 0.8em rgba(255, 255, 255, 0.3),
      0 0 0.8em rgba(255, 255, 255, 0.3);
    border: #fff solid 2px;
  }

  &:hover.white {
    color: rgba(0, 0, 0, 0.8);
    background-color: #fff;
    box-shadow: inset 0 0 0 rgba(255, 255, 255, 0.3),
      0 0 1.2em rgba(255, 255, 255, 0.5);
  }
`;
